import React, { useEffect, useMemo, useState } from "react";
import { API } from "../../pages/backend";
import { useFlutterwave } from "flutterwave-react-v3";
import {
  Box,
  Button,
  Card,
  Container,
  FormControl,
  Modal,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  InputLabel,
  Select,
  
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Popover,
  Avatar,
  TextField,
} from "@mui/material";
// import Footer from "../Footer";
import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import Layout from "../../reusables/layout/layout";
import InputField from "../forms/input/TextInput/InputField";
import { useDispatch, useSelector } from "react-redux";
import BulkPublic from "../BulkPublic";
import IndividualPublic from "../IndividualPublic";
import { examPrices } from "../../partials/examboardprices/examprices";
import FormButton from "../ui/button/FormButton";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { toast } from "react-toastify";
import Tab from "../../Component/tab";
import BillCard from "../paymentcard/billcard";
import TransactionCard from "../transactioncard/transactioncard";
import Spinner from "../ui/Spinner";
import PaymentDispute from "../disputecard/dispute";
import Examdetails from "../examcard/examdetails";
import { MdErrorOutline } from "react-icons/md";
import { MdDone } from "react-icons/md";
import BulkModel from "../BulkModel";
import data from "../dropDown";

import { showModal } from "../../store/reducers/modal";
import ResponsiveFormButton from "../ui/button/ResponsiveFormButton";
import IndividualPayerId from "../IndividualPayerId";
import Invoicedownload from "../invoice/Invoicedownload";
import PaymentDetails from "../paymentDetails/paymentdetails";
import IndividualPayment from "../IndividualPayment";
import { logOutUser } from "../../store/reducers/user";

window.console.log = () => {};  
 //  to disable every console.log
const RequsitionModel = ({ examName = "Screening", examType = "MODEL SCREENING FORM" }) => {
   // modal for construction
   const [open, setOpen] = useState(false);
   const handleOpen = () => {
     setOpen(true);
   };
 
   // Function to handle closing the modal
   const handleClose = () => {
     setOpen(false);
   };
 
   // Optional: Function to navigate away after closing modal
   const handleConfirm = () => {
     setOpen(false);
     navigate("/requisition/model/maintenance"); // Navigate if needed
   };
  const { Lga } = data;
  const [lga, setLga] = useState();
  console.log(lga)
  const [modelCollegeData, setModelCollegeData] = useState([]);

  const [modelPrice, setModelPrice] = useState(
    examPrices.modelCollegeExamFeePerCandidiate
  );
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.data.details);
  const token = useSelector((state) => state.user.data.token);
  const details = useSelector(
    (state) => state.transactionDetails.data.transactionDetails
  );
 console.log(details)
 console.log(user?.payerId)
  const [tab, setTab] = useState(0);

  const tabs = [
    "User Details",
    "Payment Details",
    // "Transaction Details",
    "Log Payment Dispute",
    // "My Bills",
  ];

  const [openBulk, setOpenBulk] = useState(false);
  const [openIndividual, setOpenIndividual] = useState(false);
  const [payerIdData, setPayerIdData] = useState(null);
  const [payerIdError, setPayerIdError] = useState();

  const [payerId, setPayerId] = useState("");
  const [loading, setLoading] = useState(false);

  // const billUrl = `${API}/bills/01?parameter=${details?.payerId ? details?.payerId : user?.payerId }`;
  // const billUrl = `${API}/bills/01?payerId=${details?.payerId ? details?.payerId : user?.payerId }`;
  const billUrl = `${API}/bills/01?userId=${user?.id}&payerId=${details?.payerId}`
  console.log(billUrl)

  const [isReadOnly, setIsReadOnly] = useState(false); // State to track if the input should be read-only
  
       // Set `payerId` and read-only status based on `schoolDetails.payerId`
        useEffect(() => {
          if (user?.payerId) {
            setPayerId(user?.payerId);
            setIsReadOnly(true); // Make input read-only if `schoolDetails.payerId` is available
          } else {
            setIsReadOnly(false); // Allow input to be editable if no `schoolDetails.payerId`
          }
        }, [user]);
  

  // const myBillsUrl = `${API}/bills/01?userId=${user?.id}`

  const handleCloseIndividual = () => {
    setOpenIndividual(false);
  };
  const handleCloseBulk = () => {
    setOpenBulk(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: { xs: "96%", md: "60%" },
    bgcolor: "background.paper",
    boxShadow: 24,
    //  py: 1,
    // px: 1,
    borderRadius: 5,
    overflowY: "auto",
    height: "50vh",
  };

  const navigate = useNavigate();

  // const handleInvoiceClick = () => {
  //     return (user?.categoryId === 2 || user?.categoryId === 3)
  //         ? navigate("/teller-preview")
  //         : " "
  // }

  const [anchorEl, setAnchorEl] = useState(null);
  const openAnchor = Boolean(anchorEl);
  const closeAnchor = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    setAnchorEl(null);
    localStorage.removeItem("firstName");
     dispatch(logOutUser())
    navigate("/");
    // navigate("/model/payment/login");
  };
  // const handleLog = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const goBack = () => {
    window.history.back();
  };

  let price = "0";

  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [amount, setAmount] = useState();

  const priceInt = modelPrice.replace(/\D/g, "");
  const totalFee = priceInt;
  // const charge = 0.01 * totalFee;
  // const totalAmount = parseInt(charge) + parseInt(totalFee);


  // const charge = useMemo(() => {
  //   let ch = 0.01 * totalFee
  //   if (ch > 3000) return 3000;
  //   return ch
  // }, [totalFee]);

  const totalAmount = parseInt(totalFee);


  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
    } catch (error) { }
  };

  const getModelCollegeBillable = async () => {
    
    const examBillable_url = `${API}/cbs/college_billables`;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
      setModelCollegeData(res?.data?.data);
      // console.log(modelCollegeData);
    } catch (error) {
      // console.log(error);
    }
  };

  const updateIndividualDetails = async () => {
    // const updateUrl = `${API}individual/02`;
    const updateUrl = `${API}/individual/01`;
    // const updateUrl = examName === "Public Service" ? publicUpdate : modelUpdate;

    try {
      const res = await axios.patch(
        updateUrl,
        { payerId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log(res);
    } catch (error) {
      // console.log(error);
    }
  };

  const generateBillNo = async () => {
    const body = {
      payer_id: payerId,
      customer_name: `${user?.firstName} ${user?.lastName}`,
      selected_quantities: [1],
      selected_items: [modelCollegeData?.[1]?.PRODUCTS_ID],
      selected_tariffs: [
        parseInt(totalFee),
      ],
      assessmentCode: '01',
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res)
      if (res?.status === 200) {
        updateIndividualDetails();
        // console.log(res?.status);
        // console.log(res?.data);
        // console.log(res?.data?.data?.responseData);

        const billdata = {
          // schoolId: '',
          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          amountGenerated: totalFee,
          customerName: `${user.firstName} ${user.lastName}`,
          quantity: 1,
          assessmentCode: "01",
          payerInfos: [
            {
              surname: `${user.lastName}`,
              firstName: `${user.firstName}`,
              middleName: `${user.middleName}`,
              locationIdOrExamId: lga,
            }
          ]
        };
        const bill = saveGeneratedBill(billdata);
        // console.log(bill)

        const userTransactionDetails = {
          payerName: `${user.firstName} ${user.lastName}`,
          productQuantity: 1,
          // price: amount,
          price: totalFee,
          // schoolName: "",
          // unitPrice: priceInt,
          email: user?.email,
          examType,
          paymentExamType: examName,
          fullDesc: "Screening Test Model College[NGN]",
          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          address: user?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        dispatch(setTransactionDetails(userTransactionDetails));

        // console.log(userTransactionDetails);
        // console.log(details);

        // dispatch(setTransactionDetails(details.billNumber = res?.data?.data?.responseData ));
        // console.log(details)
        navigate("/invoice");
      }
      // console.log(res);
    } catch (error) {
      // toast.error("Session expired. Please logout and try again.");
      // toast.error("Payer ID is required.");
      // console.log(error);
      if (error.response.status === 401 || error.response.status === 404) {
        toast.error("Session expired. Please logout and try again.");
      } else if (payerId === "") {
        toast.error("Payer ID is required");
      } else {
        toast.error("Unable to generate invoice, please try again later.");
      }
    }
  };

  // const handleInvoiceClick = async (e) => {
  //   setInvoiceLoading(true);
  //   try {
  //     e.preventDefault();
  //     if (!lga) {
  //       throw new Error("Local Government Area is Required.")
  //     }
  //     await generateBillNo();
  //     // console.log(transactionDetails)
  //     // console.log(examName)
  //   } catch (error) {
  //     // console.log(error);
  //     toast.error(error.message);
  //   } finally {
  //     setInvoiceLoading(false);
  //   }
  // };

  // const [radioValue, setRadioValue] = useState("Individual");

  // const handleRadioClick = (e) => {
  //   if (e.target.value === "Bulk") {
  //     dispatch(showModal({ content: <BulkModel payerID={payerId} /> }));
  //   } else if (e) {
  //     setRadioValue(radioValue === e ? " " : e);
  //     // dispatch(showModal({ content: <IndividualPayerId /> }));
  //   }
  // };
   

    const handleModalClick = (type) => {
      if (type === "Bulk") {
        if(!user?.payerId && !payerIdData){
          toast.error("Please verify your Payer ID before selecting Individual Payment")
          return;
        }
        dispatch(showModal({ content: <BulkModel payerID={user?.payerId || payerIdData} /> }));
      } else if (type === "Individual") {
        if (!user?.payerId && !payerIdData){
          toast.error("Please verify your Payer ID before selecting Individual Payment")
          return;
        }
        dispatch(showModal({ content: <IndividualPayment payerID={user?.payerId || payerIdData} examName={examName} /> }));
      }
    };
    
    
  // Payer Id verification

  const updatePayerId = async () => {
    try {
      await axios.patch(`${API}/individual/01`, {
        payerId: payerId,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Payer ID updated successfully!');
    } catch (error) {
      console.error('Failed to update payer ID:', error);
      toast.error('Failed to update payer ID. Please try again.');
    }
  };

  const payerIdVerification = async () => {
    try {
      const res = await axios.get(
        `${API}/cbs/customer_details?payerId=${payerId}`
      );
      // console.log(res);
      if (
        res.status === 200 &&
        payerId === res?.data?.data?.customer?.[0]?.PAYER_ID
      ) {
        setPayerIdError(null);
        // console.log(res?.data?.data?.customer?.[0]?.CUSTOMER_NAME);
        setPayerIdData(res?.data?.data?.customer?.[0].PAYER_ID);
        toast.success(
          `Payer ID verified successfully, Customer Name: ${res?.data?.data?.customer?.[0]?.CUSTOMER_NAME}`,
          {
            autoClose: 10000,
          }
        );
        await updatePayerId()
      }
    } catch (error) {
      if (error?.response && error?.response?.status === 404) {
        setPayerIdData(null);
        setPayerIdError(error?.response?.data?.message);
        toast.error(error?.response?.data?.message);
      }
      // console.log(error);
    }
  };

  useEffect(()=>{
     if (isReadOnly){
      payerIdVerification()
     }
  }, [payerId, isReadOnly])



  const ReqFormModel = () => {
    return (
      <Container sx={{ mt: 5 }}>
        <div
          style={{
            marginTop: "32px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding:
              window.innerWidth >= 1280
                ? "0px 30px"
                : window.innerWidth >= 414
                  ? "0px 0px"
                  : "0px",
          }}
        >
          <div>
            <Grid container spacing={6}>
              <Grid item xs={6}>
              <InputField
                  name="lastName"
                  label="Surname"
                  type="lastName"
                  placeholder="Last Name"
                  value={user?.lastName}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  readOnly
                  style={{ height: "100%", textTransform: "capitalize" }}
                />
              </Grid>
              <Grid item xs={6}>
              <InputField
                  name="firstName"
                  label="First Name"
                  type="firstName"
                  placeholder="First Name"
                  value={user?.firstName}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  readOnly
                  style={{ height: "100%", textTransform: "capitalize" }}
                />
               
              </Grid> 
            </Grid>
          </div>

          <div>
            <Grid container spacing={6}>
              <Grid item xs={6}>
              <InputField
                  name="middleName"
                  label="Middle Name"
                  type="text"
                  placeholder="Middle Name"
                  // value={user?.middleName}
                  style={{ height: "100%", textTransform: "capitalize" }}
                />
              </Grid>
              <Grid item xs={6} style={{ position: "relative" }}>
                <div style={{ position: "absolute", right: "2.5%", marginTop: "4%", textDecoration: "underline", cursor: "pointer", color: "#35a66f"}} onClick={() => dispatch(showModal({ content: <IndividualPayerId />}))} >Get Payer ID?</div>
                <InputField
                  name="payerId"
                  label="Payer ID"
                  placeholder="Enter Your Payer ID"
                  value={payerId}
                  onChange={(e) => {
                    if (!isReadOnly) setPayerId(e.target.value)
                  }}
                  
                  onBlur={() =>   payerIdVerification()}
                  readOnly={isReadOnly}
                  type="text"
                  style={{ height: "100%" }}
                />
                {
                  payerIdError != null ? <span style={{ fontSize: '14px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '5px', color: 'red' }} >Payer ID unverified {" "} <MdErrorOutline /> </span> :
                    payerIdData != null ? <span style={{ fontSize: '14px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '5px', color: 'green' }} >Payer ID verified {" "} <MdDone /> </span> : ''
                }
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container spacing={6}>
              <Grid item xs={12} md={6}>
                <InputField
                  name="Phone No"
                  label="Phone No"
                  type="phone"
                  placeholder="Enter phone number"
                  value={user?.phoneNumber}
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputField
                  name="email"
                  label="Email"
                  type="email"
                  placeholder="Email"
                  value={user?.email}
                  style={{ height: "100%" }}
                />
              </Grid>
            </Grid>
          </div>

          {/* <div> */}
              {/* <FormLabel component="legend">Test Type</FormLabel> */}
            {/* <FormControl component="fieldset">
              <RadioGroup
  aria-label="payment-options"
  name="radio-button"
  onChange={handleRadioClick}
>
  <FormControlLabel
    value="Individual"
    control={<Radio />}
    label="Single Payment"
    style={{ marginTop: "2rem" }}
  />
  <FormControlLabel
    value="Bulk"
    control={<Radio />}
    label="Bulk Payment"
  />
</RadioGroup>
            </FormControl> */}
            {/* <div>
            <FormControlLabel
                  value="payerId"
                  control={<Radio />}
                  label="Get Payer ID"
                  onChange={handleRadioClick}
                />
            </div> */}
          {/* </div> */}


          {/* <div style={{ marginTop: "2rem" }}>
            <Grid container>
              <Grid item xs={6}>
                <InputField
                  name="test-price"
                  label="Amount"
                  type="number"
                  placeholder="Enter Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  style={{ height: "100%" }}
                />
              </Grid>
            </Grid>
          </div> */}

<div
            style={{
              marginTop: "3rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ResponsiveFormButton
              width="medium"
              type="button"
              label={
                invoiceLoading ? <Spinner width="30" /> : " Single Payment"
              }
              onClick={(event) => handleModalClick("Individual", event)}
              // onClick={handleOpen}


              // onClick={handleInvoiceClick}
            />
                        {/* Modal (Dialog) Component */}
                        <Dialog open={open} onClose={handleClose}>
              <DialogTitle>
                <Typography variant="h6" align="center">
                Payment for this Exam had been Disabled.

                </Typography>
              </DialogTitle>
              <DialogContent>
                <Typography variant="body1" align="center" gutterBottom>
                Please proceed to the Screening Exam Portal to Continue your Registration 

                </Typography>
                <Typography variant="body2" align="center">
      <Link
        href="https://screeningtest.examsboard.lagosstate.gov.ng/"
        target="_blank" rel="noopener noreferrer"
        rel="noopener noreferrer"
        underline="hover"  // Adds an underline on hover
        color="primary"    // Customize the color if needed
      >
        https://screeningtest.examsboard.lagosstate.gov.ng/
      </Link>
    </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} sx={{ color: "#34A56F", "&:hover": { color: "#2D905E" } }}>
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            <div>
              <ResponsiveFormButton
              type="button"
                // width="medium" 
                // label={" Go Back"} onClick={goBack} 
                label="Bulk Payment"
                onClick={(event) => handleModalClick("Bulk", event)}
                // onClick={handleOpen}
                />
            </div>
          </div>

          {/* <Grid
            container
            alignItems={"center"}
            alignContent={"center"}
            my={2}
            spacing={2}
          ></Grid> */}

          {/* <Grid container spacing={6}>
            <Grid item xs={6}>
              <InputField
                name="test-price"
                label="Price per Candidate"
                type="text"
                value={modelPrice}
                style={{ height: "100%" }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="body1"
                sx={{
                  color: "#9b9494",
                  fontSize: "1rem",
                  fontWeight: "bolder",
                  paddingTop: "1.2rem",
                }}
              >
                Local Government
              </Typography>
              <TextField
                label="Select Local Government Area"
                select
                value={lga}
                onChange={(e) => setLga(e.target.value)}
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                {Lga.map((lgaItem) => (
                  <MenuItem key={lgaItem.ledId} value={lgaItem.ledId}>
                    {lgaItem.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid> */}

          {/* <div
            style={{
              marginTop: "3rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ResponsiveFormButton
              // width="medium"
              label={
                invoiceLoading ? <Spinner width="30" /> : " Generate Invoice"
              }
              onClick={handleInvoiceClick}
            />

            <div>
              <ResponsiveFormButton
                // width="medium" 
                label={" Go Back"} onClick={goBack} />
            </div>
          </div> */}
        </div>
      </Container>
    );
  };

  // const PaymentForm = () => {
  //   return <BillCard url={billUrl} />;
  // };

  // const PlatformTransactionDetails = () => {
  //   return <TransactionCard />;
  // };

  useEffect(() => {
    getModelCollegeBillable();
  }, []);

  return (
    <div>
      {/* <Layout> */}
      <Card className="model-card" elevation={5}>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          className="bece-form-left"
          onSubmit={(e) => e.preventDefault()}
        >
          <div style={{ padding: "0px 5px" }}>
            <marquee bgcolor="white" direction="left" loop="">
              <Typography>
                <span
                  style={{
                    color: "red",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  *Late Registration attracts an additional fee
                </span>
              </Typography>
            </marquee>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "5px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  paddingTop: "10px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    // marginLeft: "10px",
                    // paddingTop: "8px",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Welcome back
                </Typography>
                <Typography
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {user?.firstName + " " + user?.lastName}
                </Typography>
              </div>
              <div>
                <Avatar
                  className=" lg:!flex xs:!hidden items-center"
                  size="large"
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                  aria-label="account-circle"
                  style={{
                    backgroundColor: "#34A56F",
                    // lineHeight: '50px',
                    fontFamily: "Palanquin",
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    width: "35px",
                    height: "35px",
                    display: "flex",
                  }}
                >
                  {user?.firstName?.charAt(0)?.toUpperCase() +
                    user?.lastName?.charAt(0)?.toUpperCase()}
                </Avatar>
                <Popover
                  open={openAnchor}
                  anchorEl={anchorEl}
                  onClose={closeAnchor}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                </Popover>
                <div 
                 style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  paddingTop: "10px",
             
                }}
                >{user?.payerId}</div>
              </div>
             
            </div>
          </div>
          <Typography
            variant="h5"
            align="center"
            sx={{ paddingTop: "1.5rem", fontWeight: "bold" }}
          >
            {examType}
          </Typography>

          <div>
            {tabs.map((x, i) => (
              <Tab
                tabs={tabs}
                key={i}
                text={x}
                active={i === tab}
                onClick={setTab}
              />
            ))}
          </div>
          {tab === 0 && ReqFormModel()}
          {tab === 1 && <BillCard url={billUrl} examName={examName} />}
          {/* {tab === 2 && <TransactionCard />} */}
          {tab === 2 && <PaymentDispute type={examType} />}
          {/* {tab === 3 && < PaymentDetails myBills={myBillsUrl} />} */}          
        </Box>
        <Box compnent="div" className="model-form-right">
          <Typography
            variant="h4"
            align="center"
            sx={{ color: "#ffffff", fontWeight: "bold" }}
          >
            Lagos State Exam Board
          </Typography>
          <img
            src={
              "/assets/images/laags.png"
            }
            alt="logo"
          />
          <Typography
            variant="h4"
            align="center"
            sx={{ color: "white", fontWeight: "bold", mb: 1 }}
          >
            {examName}
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{ color: "white", fontSize: "20px" }}
          >
            Fill the form to request for the Official Central Billing System
            Invoice ID
          </Typography>
        </Box>
      </Card>
      <Modal
        open={openIndividual}
        onClose={handleCloseIndividual}
        keepMounted
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>
          <IndividualPublic
            handleClose={handleCloseIndividual}
            data={user?.payerId}
          />
        </Box>
      </Modal>
      <Modal
        open={openBulk}
        onClose={handleCloseBulk}
        keepMounted
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style} className="modal-scrollbar">
          <BulkPublic handleClose={handleCloseBulk} data={user?.payerId} />
        </Box>
      </Modal>
      {/* <ProceedModalPrint pin={pinNum} open={open} handleClose={handleClose} /> */}
      {/* </Layout> */}
      {/* <Footer /> */}
    </div>
  );
};

export default RequsitionModel;
